import { mapGetters, mapState, mapMutations, mapActions } from "vuex";
import ClickOutside from "vue-click-outside";
import { dadataJoin as join, fireNativeEvent } from "../../../_scripts/helpers";
import DropdownModern from "../../dropdown-modern/dropdown-modern";
import { scrollTo } from '../../../_scripts/helpers';

export default {
	template: "#checkout-delivery",
	props: {
		step: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			formValidator: null,
			pickupPointError: false,
			map: null,
			mapView: false,
			visibleGeoCollection: null,
			mapPlacemarks: [],
			addingNewAddress: false,
			editingUserAddress: false,
			showErrors: false
		}
	},
	components: {
		"dropdown-modern": DropdownModern
	},
	computed: {
        ...mapGetters({
			deliveries: "delivery/deliveries",
			activeDelivery: "delivery/activeDelivery",
			pickupPoints: "delivery/pickupPoints",
			userAddresses: "delivery/userAddresses",
			activeUserAddress: "delivery/activeUserAddress",
			activeStep: "checkout/activeStep",
		}),
		...mapState({
			props: state => state.delivery.props,
			errorMessages: state => state.checkout.errorMessages,
			dadataToken: state => state.checkout.dadataToken,
			extra: state => state.checkout.extra
		}),
		formProps() {
			return this.props.filter(
				prop => prop.code !== "PICKUP_POINT"
				&& prop.code !== "DELIVERY_TIME"
				&& prop.code !== "ADDRESSES"
				&& prop.code !== "SDEK_PICKUP_ADDRESS"
				&& !prop.form);
		},
		selectedPickupPoint() {
			return this.pickupPoints.find(point => point.checked);
		},
		deliveryDate() {
			return this.props.find(prop => prop.code === "DELIVERY_TIME") || null;
		},
		pickupAddress() {
			return this.props.find(prop => prop.code === "SDEK_PICKUP_ADDRESS") || null;
		},
		activeDeliveryDate() {
			return (this.deliveryDate && this.deliveryDate.value) ? this.deliveryDate.value.find(date => date.checked) : null;
		},
		activeDeliveryTime() {
			return (this.activeDeliveryDate) ? this.activeDeliveryDate.time.find(time => time.checked) : null;
		},
		deliveryDateOptions() {
			return (this.deliveryDate) ? this.deliveryDate.value : [];
		},
		deliveryTimeOptions() {
			return (this.activeDeliveryDate) ? this.activeDeliveryDate.time : [];
		},
		showPickupPoints() {
			return (!!this.pickupPoints.length && this.activeDelivery);
		},
		showSdekPickup() {
			return this.activeDelivery.CODE === "SdekPickup";
		},
		showSdekPostamat() {
			return this.activeDelivery.CODE === "SdekPostamat";
		},
		isSdekCourier() {
			return this.activeDelivery.CODE === "SdekCourier";
		},
		stepDisabled() {
			return this.step.disabled;
		},
		isActive() {
			return this.step.id === this.activeStep.id;
		},
		deliveryMessage() {
			return this.extra.deliveryMessage;
		},
		showNewAddressForm() {
			return (!this.userAddresses.length || this.addingNewAddress || this.editingUserAddress) ? true : false;
		},
		servicesFormFields() {
			return this.props.filter(prop => prop.form && prop.form.split("/")[0] === "services");
		},
		toTheFloorFormFields() {
			return this.props.filter(prop => prop.form && prop.form === "services/toTheFloor");
		},
		loaderFormFields() {
			return this.props.filter(prop => prop.form && prop.form === "services/loader");
		},
		garbageCollectionFormFields() {
			return this.props.filter(prop => prop.form && prop.form === "services/garbageCollection");
		},
		showServicesForm() {
			return !!this.servicesFormFields.length;
		},
		toTheFloorCheckbox() {
			return this.toTheFloorFormFields.find(prop => prop.code === "CHECKED_TO_THE_FLOOR");
		},
		loaderCheckbox() {
			return this.loaderFormFields.find(prop => prop.code === "CHECKED_LOADER");
		},
		garbageCollectionCheckbox() {
			return this.garbageCollectionFormFields.find(prop => prop.code === "CHECKED_GARBAGE_COLLECTION");
		},
		sdekPickupSet() {
			let address = this.props.find(prop => prop.code === "ADDRESS");
			return address ? address.value !== '' : false;
		},
	},
	methods: {
		...mapMutations({
			setActiveDelivery: "delivery/setActiveDelivery",
			setActivePickupPoint: "delivery/setActivePickupPoint",
			setPropValueMutation: "delivery/setPropValue",
			unselectUserAddresses: "delivery/unselectUserAddresses",
			setActiveUserAddressMutation: "delivery/setActiveUserAddress",
			setActiveDate: "delivery/setActiveDate",
			setActiveTime: "delivery/setActiveTime",
			setRadioPropValue: "delivery/setRadioPropValue",
			setStepValidState: "checkout/setStepValidState",
		}),
		...mapActions({
			refreshOrder: "checkout/refreshOrder",
			nextStep: "checkout/nextStep",
			blockSteps: "checkout/blockSteps"
		}),
		changeType(id) {
			this.setActiveDelivery(id);
			this.setPropValueMutation({value: "", code: "SDEK_PICKUP_ADDRESS"});
			this.setPropValueMutation({value: "", code: "ADDRESS"});
			this.refreshOrder().then(() => {
				if (this.showNewAddressForm) {
					this.initForm();
				}
				this.setActiveDate();

				this.setActiveDelivery(id);
				this.addingNewAddress = false;
				this.checkComponentValidity();
			});
		},
		clickOutside() {
			if (this.isActive && this.activeDelivery) {
				if (this.showNewAddressForm) {
					this.touchForm();
				}
				if (this.showPickupPoints) {
					this.pickupPointError = (this.selectedPickupPoint) ? false : true;
				}
			}
			this.showErrors = true;
		},
		touchForm() {
			$(this.$refs.form).valid();
		},
		selectPickupPoint(id) {
			this.setActivePickupPoint(id);
			this.pickupPointError = false;
		},
		handleFormInput(e, code) {
			this.setPropValueMutation({value: e.target.value, code});
			this.checkComponentValidity();
		},
		handleRadioInput(value, code) {
			this.setRadioPropValue({value, code});
			this.checkComponentValidity();
		},
		handleFormBlur(e) {
			fireNativeEvent(e.target, "input");
		},
		getChangeHandler(code) {
			if (code === "CITY") {
				this.refreshOrder();
			}
		},
		reinitInputs() {
			this.$nextTick(() => {
				if (window.initInputModern) window.initInputModern();
			});
		},
		initForm() {
			this.reinitInputs();
			this.formValidator = $(this.$refs.form).validate();
			this.initDadata();
		},
		initDadata() {
			let $city = $("[data-checkout-input-code='CITY']").find("input");
			let $address = $("[data-checkout-input-code='ADDRESS']").find("input");

			$city.suggestions({
				token: this.dadataToken,
				type: "ADDRESS",
				hint: false,
				bounds: "city",
				onSelectNothing: () => {
					$address.suggestions().setOptions({constraints: {}});
				},
				onSelect: (data) => {
					let city = data.data.city;
					$address.suggestions().setOptions({
						constraints: {
						   locations: {
						   	   city
						   }
						},
					});
					this.setPropValueMutation({value: city, code: "CITY"});
					this.setPropValueMutation({value: city, code: "CITY_TO"});
					this.checkComponentValidity();
                    $city[0].blur();
				},
				formatSelected: (selected) => {
					return selected.data.city
				}
			});

			$address.suggestions({
			    token: this.dadataToken,
			    type: "ADDRESS",
				restrict_value: true,
			    constraints: {
					locations: {
						city: $city.val()
					}
				},
				onSelect: data => {
					const address = data.data;
					const value = join([
						address.street_with_type,
						join([address.house_type, address.house,
							  address.block_type, address.block], " "),
						join([address.flat_type, address.flat], " ")
					]);
					this.setPropValueMutation({value, code: "ADDRESS"});
					this.checkComponentValidity();
					$address[0].blur();
				},
			});
		},
		setActiveUserAddress(id) {
			this.setActiveUserAddressMutation(id);
			this.addingNewAddress = false;
			this.editingUserAddress = false;
			this.refreshOrder().then(() => {
				this.checkComponentValidity();
			});
		},
		editUserAddress(id) {
			this.addingNewAddress = false;
			this.editingUserAddress = true;
			this.setActiveUserAddressMutation(id);
			this.refreshOrder().then(() => {
				this.initForm();
				this.checkComponentValidity();
				scrollTo(this.$refs.formTitle);
			});
		},
		addNewAddress() {
			this.addingNewAddress = true;
			this.editingUserAddress = false;
			this.clearFormProps();
			this.unselectUserAddresses();
			this.$nextTick(() => {
				this.initForm();
				scrollTo(this.$refs.formTitle);
			});
		},
		clearFormProps() {
			this.formProps.forEach(prop => {
				if (prop.code !== "CITY") return this.setPropValueMutation({value: "", code: prop.code})
			});
		},
		isFormValid() {
			const result = this.formValidator.checkForm();
			this.formValidator.submitted = {};
			return result;
		},
		checkComponentValidity() {
			let valid = false;

			if (this.showPickupPoints) {
				if (this.selectedPickupPoint) valid = true;
			} else {
				if (this.showNewAddressForm && this.formValidator) {
					valid = this.isFormValid() ? true : false;
				} else {
					valid = this.activeUserAddress ? true : false;
				}
			}

			if (this.deliveryDate && (this.deliveryDate.error || this.activeDeliveryTime === null || this.activeDeliveryTime === undefined)) {
				valid = false;
			}

			if (this.sdekPickupSet && (this.showSdekPickup || this.showSdekPostamat)) {
				valid = true;
			}
			this.setStepValidState({stepId: this.step.id, value: true});
			this.nextStep(this.step);

			if (valid) {
				this.setStepValidState({stepId: this.step.id, value: true});
				this.nextStep(this.step);
			} else {
				this.setStepValidState({stepId: this.step.id, value: false});
				this.blockSteps();
			}
		},
		initMap() {
			let vueContext = this;

			let squareLayout = ymaps.templateLayoutFactory.createClass(
				`<div class="map-placemark">
					<div class="map-placemark__icon"></div>
					<div class="map-placemark__text">{{properties.pointName|raw}}</div>
				</div>`
			);

			let balloonLayout = ymaps.templateLayoutFactory.createClass(
				`<div class="map-balloon" data-balloon-id={{properties.pointId}}>
			    	<div class="map-balloon__wrapper">
					    $[[options.contentLayout]]
			    	</div>
			    </div>`, {
					build: function() {
						this.constructor.superclass.build.call(this);
						$(".map-balloon").css("top", -($(".map-balloon").outerHeight()));
						$(".map-balloon").css("left", -20);
						$("[data-balloon-choose]").bind("click", this.chooseShop.bind(this));
					},

					clear: function() {
						$("data-balloon-choose").unbind('click', this.chooseShop);
						this.constructor.superclass.clear.call(this);
					},

					chooseShop: function() {
						let id = $(".map-balloon").attr("data-balloon-id");
						vueContext.setActivePickupPoint(id);
						vueContext.mapPlacemarks.forEach(placemark => {
							placemark.properties.set("pointChosen", (placemark.properties.get("pointId") === id) ? true : false);
						});
					}
				}
			);

			let balloonContentLayout = ymaps.templateLayoutFactory.createClass(
		        `<div class="map-balloon__section">
		        	<p class="map-balloon__text map-balloon__title h5">{{properties.pointName|raw}}</p>
		        	<p class="map-balloon__text p5 text-new-gray">{{properties.pointAddress|raw}}</p>
		        </div>
		        <div class="map-balloon__section">
		        	<p class="map-balloon-text p5">{{properties.pointSchedule|raw}}</p>
				</div>

				{% if !properties.pointChosen %}
				    <div class="map-balloon__section" data-balloon-choose>
			        	<button type="submit" class="button button--transparent button--small">
			        		<span class="button__wrapper">
			        			<span class="button__text">Выбрать</span>
			        		</span>
			        	</button>
			        </div>
				{% else %}
				    <div class="map-balloon__section">
			        	<button type="submit" class="button button--green button--small">
			        		<span class="button__wrapper">
			        			<span class="button__text">Выбрано</span>
			        		</span>
			        	</button>
					</div>
				{% endif %}`
			);

			this.visibleGeoCollection = new ymaps.GeoObjectCollection();

			this.map = new ymaps.Map($("[data-delivery-map]")[0], {
				center: [55.74954, 37.621587],
				zoom: 10,
				controls: []
			});

			this.map.geoObjects.add(this.visibleGeoCollection);

			this.pickupPoints.forEach((point) => {
				let coords = [point.coords[0], point.coords[1]];

				let pin = new ymaps.Placemark(coords, {
			    	pointName: point.name,
			    	pointAddress: point.address,
			    	pointSchedule: point.schedule,
					pointChosen: !!point.checked,
					pointId: point.id
			    }, {
			    	iconLayout: squareLayout,
                    iconShape: {
                        type: 'Rectangle',
                        coordinates: [
                            [0, 0], [150, 25]
                        ]
			    	},
			    	iconOffset: [-50, 0],
			    	balloonContentLayout: balloonContentLayout,
			    	balloonLayout: balloonLayout,
			    	balloonPanelMaxMapArea: 0,
			    	balloonOffset: [0, 0]
			    });

				this.mapPlacemarks.push(pin);
				this.visibleGeoCollection.add(pin);

				pin.events.add(["click", "touchstart"], () => {
					this.map.setCenter(coords, 16);
				}, {passive: true});

				if (point.checked) {
					pin.balloon.open();
				}
			});

			this.map.setBounds(this.map.geoObjects.getBounds(), { checkZoomRange: true }).then((err) => {
				if (err) return false;
				var zoom = this.map.getZoom();
				if (zoom > 16) {
					this.map.setZoom(16);
				}
			});

			this.map.events.add("click", e => e.get("target").balloon.close());
		},
		selectDate(data) {
			this.setActiveDate(data.id);
			this.checkComponentValidity();
		},
		selectTime(data) {
			this.setActiveTime(data.id);
			this.checkComponentValidity();
		},
		handleServiceChange(e, service) {
			this.setPropValueMutation({value: e.target.checked, code: `CHECKED_${service}`});
			this.refreshOrder().then(() => {
				this.checkComponentValidity();
				this.reinitInputs();
			});
		},
		handleSdekPickupPointSet(id, city, address) {
			this.setPropValueMutation({value: address, code: "ADDRESS"});
			this.setPropValueMutation({value: city, code: "CITY"});
			this.setPropValueMutation({value: address, code: "SDEK_PICKUP_ADDRESS"});
			this.refreshOrder().then(() => {
				this.checkComponentValidity();
				this.reinitInputs();
			});
		}
	},
	watch: {
		selectedPickupPoint(val) {
			if (val) this.$nextTick(() => this.checkComponentValidity());
		},
		stepDisabled(val) {
			if (!val) {
				this.$nextTick(() => this.checkComponentValidity());
			}
		},
		mapView(val) {
			if (val) {
				this.$nextTick(() => {
			        if (window.ymapsReady) {
			        	this.initMap();
			        } else {
			        	document.addEventListener('ymaps-ready', () => this.initMap());
			        }
				});
			} else {
				this.map.destroy();
			}
		},
	},
	directives: {
		ClickOutside
	},
	mounted() {
		if (this.showForm) {
			this.initForm();
		}
		this.$nextTick(() => this.checkComponentValidity());
	},
	created() {
		$(document).on("click", "#SDEK_button", (e) => {
			this.handleSdekPickupPointSet('##S' + IPOLSDEK_pvz.pvzId, IPOLSDEK_pvz.city, IPOLSDEK_pvz.pvzAdress);
		});
	}
}
